import { NotificationListPage } from "@/features/notifications/view/NotificationList/NotificationListPage";

export const ChatNotificationsPage = () => {
  return <NotificationListPage type="chat" title="We're missing something" />;
};
